module.exports = __webpack_public_path__ + "img/how-to-install-extension.71f4c4bd.png";